import React from "react"

function IconLightbulb({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="lightbulb"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-lightbulb"
      {...props}
    >
      <path
        d="M11.588 2.619a7.332 7.332 0 0 1 3.822 13.587l-.246.144V18c0 .807-.548 1.486-1.291 1.686a2.173 2.173 0 0 1-4.322.038 1.743 1.743 0 0 1-1.47-1.562L8.072 18v-1.623l-.065-.029a7.328 7.328 0 0 1-3.748-6.111l-.005-.286a7.332 7.332 0 0 1 7.333-7.332zm.945 17.127h-1.646a.864.864 0 0 0 1.645 0zm1.322-3.274H9.382V18c0 .18.11.336.266.402l.082.025.088.01h3.6c.211 0 .387-.15.428-.35l.009-.087v-1.528zM11.588 3.928a6.023 6.023 0 0 0-3.163 11.147l.079.047h6.167l.08-.047a6.021 6.021 0 0 0 2.837-4.588l.018-.273.006-.263a6.023 6.023 0 0 0-6.024-6.023z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconLightbulb
